import { noop } from '@crocodille/common';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import styles from './cart-quantity.module.scss';

export interface CartQuantityProps {
  value: number;
  min?: number;
  max?: number;
  disabled?: boolean;
  disabledDecrement?: boolean;
  disabledIncrement?: boolean;
  onChange?: (value: number) => void;
}

const CartQuantity: React.FC<React.PropsWithChildren<CartQuantityProps>> = ({
  value,
  disabled = false,
  disabledDecrement = false,
  disabledIncrement = false,
  min = 0,
  max = Infinity,
  onChange = noop,
}) => {
  const { t } = useTranslation();

  const [inputValue, setInputValue] = useState(value);
  useEffect(() => void setInputValue(value), [value]);

  return (
    <div className={styles.container}>
      <button
        type="button"
        className={cn(styles.button, styles.decrease)}
        aria-label={t('cart.decrease_quantity')}
        onClick={() => onChange(value - 1)}
        disabled={disabled || disabledDecrement || value <= min}
      >
        <span>-</span>
      </button>
      <input
        type="number"
        className={styles.input}
        value={inputValue}
        min={min}
        max={max === Infinity ? undefined : max}
        disabled={disabled}
        onChange={(e) => setInputValue(parseInt(e.target.value))}
        onBlur={() => onChange(inputValue)}
        onKeyUp={(e) => e.key === 'Enter' && onChange(inputValue)}
      />
      <button
        type="button"
        className={cn(styles.button, styles.increase)}
        aria-label={t('cart.increase_quantity')}
        onClick={() => onChange(value + 1)}
        disabled={disabled || disabledIncrement || value >= max}
      >
        <span>+</span>
      </button>
    </div>
  );
};

export default CartQuantity;
